import Badge from "@mui/material/Badge";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import Link from "@mui/icons-material/Link";
import Hub from "@mui/icons-material/Hub";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { ContentContainer as HXContentContainer, Parent as HXParent, LighterText, mobilePageHPadding, Subtitle, } from "./HXMobilePage.styles";
import { multilineEllipsis } from "./base.styles";
import { FlexColumn, FlexRow, HorizontalDivider } from "./common.styles";
export const Parent = styled(HXParent) `
    margin-top: 0;
`;
export const SectionTitle = styled(Subtitle) `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const ZeroStateCardContainer = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 24px;
    padding: 20px;
    gap: 12px;
    align-items: center;
    text-align: center;
`;
export const ZeroStateIconWrapper = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background-color: ${colors.blue_10};
    color: ${colors.blue_main};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    align-self: center;

    & > * {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
const BaseZeroStateIcon = css `
    width: 36px;
    height: 36px;
    color: ${colors.blue_50};
`;
export const ZeroStateIconLink = styled(Link) `
    ${BaseZeroStateIcon}
`;
export const ZeroStateIconHub = styled(Hub) `
    ${BaseZeroStateIcon}
`;
export const ZeroStateCardTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.15px;
    line-height: normal;
    color: ${colors.black_lighter};
    width: 100%;
`;
export const ZeroStateCardDescription = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    line-height: normal;
    color: ${colors.black_lighter};
    width: 100%;
    white-space: pre-wrap;
`;
export const SectionBlock = styled(FlexColumn) `
    gap: 12px;
    align-self: stretch;
`;
export const MobilePageHPaddingWrapper = styled(SectionBlock) `
    padding: 0 ${mobilePageHPadding}px;
`;
export const ContentContainer = styled(HXContentContainer) `
    padding: 20px 0 16px 0;
`;
export const CardContainer = styled(FlexColumn) `
    padding: 16px ${mobilePageHPadding}px;
    gap: 16px;
    border-bottom: 1px solid ${colors.black_4};
`;
export const SHLLinkList = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 12px;
    overflow: hidden;
`;
export const SHLLinkRow = styled(FlexRow) `
    padding: 12px;
    gap: 16px;
    align-items: center;
    cursor: pointer;
`;
export const SHLLinkIcon = styled(FlexRow) `
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background-color: ${colors.blue_10};
    color: ${colors.navy_main};
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-self: center;

    & > * {
        width: 20px;
        height: 20px;
    }
`;
export const SHLLinkText = styled(FlexColumn) `
    flex: 1;
    min-width: 0;
    gap: 2px;
`;
export const SHLLinkTitle = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    ${multilineEllipsis(2)}
`;
export const SHLLinkDescription = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    color: ${colors.black_light};
    ${multilineEllipsis(2)}
`;
export const SHLLinkStatusLine = styled.div `
    font-size: ${fontSizes.LITTLE};
    color: ${({ $active }) => ($active ? colors.forest_main : colors.black_lighter)};
`;
export const SHLLinkChevron = styled.div `
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const ArrowForwardIosIcon = styled(ArrowForwardIos) `
    color: ${colors.navy_main};
    width: 20px;
    height: 20px;
    opacity: 0.7;
`;
export const SHLRowDivider = styled(HorizontalDivider) `
    border-color: ${colors.blue_10};
`;
export const InactiveLinksSection = styled(FlexColumn) `
    background: ${colors.white_main};
    border: 1px solid ${colors.blue_10};
    border-radius: 12px;
    overflow: hidden;
`;
export const InactiveLinksHeader = styled(FlexRow) `
    padding: 12px;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    gap: 8px;

    & > span:first-child {
        font-size: ${fontSizes.MEDIUM};
        font-weight: ${fontWeights.SEMI_BOLD};
        color: ${colors.black_main};
    }
`;
export const PatientListDate = styled(LighterText) `
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
`;
export const PatientListPatientFriendlyTitle = styled(Subtitle) `
    ${multilineEllipsis(1)}
    font-size: ${fontSizes.MEDIUM};
    letter-spacing: 0.17px;
    font-weight: ${({ isBold }) => (isBold ? fontWeights.BOLD : fontWeights.NORMAL)};
    white-space: pre-wrap;
`;
export const PatientListOrgName = styled(LighterText) `
    ${multilineEllipsis(1)}
    font-size: ${fontSizes.SMALL};
    letter-spacing: 0.17px;
    font-weight: ${({ isBold }) => (isBold ? fontWeights.SEMI_BOLD : fontWeights.NORMAL)};
`;
export const PatientListNeedingActionBadge = styled(Badge) `
    background-color: ${colors.accents_sunset};
    width: 8px;
    height: 8px;
    border-radius: 100px;
`;
export const UpdateYourRecords = styled(FlexColumn) `
    padding: 16px;
    border-radius: 12px;
    background-color: ${colors.blue_5};
    justify-content: center;
    align-items: flex-start;
`;
export const PatientListOrgLogoContainer = styled(FlexRow) `
    width: 36px;
    height: 36px;
    align-self: center;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
`;
export const PatientListOrgLogoImg = styled.img.attrs({ width: "100%", height: "100%" }) `
    object-fit: contain;
`;
